import { render, staticRenderFns } from "./JoinScreen.vue?vue&type=template&id=3184af8e&scoped=true&"
import script from "./JoinScreen.vue?vue&type=script&lang=ts&"
export * from "./JoinScreen.vue?vue&type=script&lang=ts&"
import style0 from "./JoinScreen.vue?vue&type=style&index=0&id=3184af8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3184af8e",
  null
  
)

export default component.exports